<template>
  <div class="info-layout">
    <!-- Minimal header -->
    <header class="info-header">
      <div class="info-header__inner">
        <RouterLink to="/" class="info-header__logo">
          <img src="/new-logo.png" class="info-header__logo-mark" alt="">
          <span class="info-header__logo-text">Maths Eleven Plus</span>
        </RouterLink>
        <nav class="info-header__nav">
          <RouterLink to="/info/faq" class="info-header__link">FAQ</RouterLink>
          <RouterLink to="/info/about" class="info-header__link">About</RouterLink>
          <RouterLink to="/info/contact" class="info-header__link">Contact</RouterLink>
        </nav>
        <div class="info-header__auth">
          <template v-if="isAuthenticated">
            <RouterLink to="/parent/dashboard" class="info-header__cta">Dashboard →</RouterLink>
          </template>
          <template v-else>
            <RouterLink to="/auth/login" class="info-header__signin">Sign in</RouterLink>
            <RouterLink to="/auth/register" class="info-header__cta">Begin Free</RouterLink>
          </template>
        </div>
      </div>
    </header>

    <!-- Page content -->
    <main class="info-main">
      <RouterView />
    </main>

    <SiteFooter />
  </div>
</template>

<script setup>
import SiteFooter from '@/components/layout/SiteFooter.vue';
import { useAuth } from '@/composables/useAuth';
const { isAuthenticated } = useAuth();
</script>

<style scoped>
.info-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F9F6EF;
  font-family: 'Jost', sans-serif;
}

.info-header {
  background: #0D1628;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid rgba(184,144,42,0.2);
}
.info-header__inner {
  max-width: 72rem;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 60px;
  display: flex;
  align-items: center;
  gap: 2rem;
}
.info-header__logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  flex-shrink: 0;
}
.info-header__logo-mark { width: 22px; height: 22px; flex-shrink: 0; }
.info-header__logo-text {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
}

.info-header__nav {
  display: flex;
  gap: 1.5rem;
  flex: 1;
}
@media (max-width: 600px) { .info-header__nav { display: none; } }

.info-header__link {
  font-size: 0.875rem;
  color: rgba(255,255,255,0.65);
  text-decoration: none;
  transition: color 0.15s;
}
.info-header__link:hover,
.info-header__link.router-link-active { color: #fff; }

.info-header__auth {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
  flex-shrink: 0;
}
.info-header__signin {
  font-size: 0.875rem;
  color: rgba(255,255,255,0.65);
  text-decoration: none;
  transition: color 0.15s;
}
.info-header__signin:hover { color: #fff; }
.info-header__cta {
  background: linear-gradient(135deg, #B8902A, #d4a843);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.4rem 1rem;
  border-radius: 0.375rem;
  text-decoration: none;
  transition: opacity 0.15s;
}
.info-header__cta:hover { opacity: 0.9; }

.info-main {
  flex: 1;
}
</style>
